import { render, staticRenderFns } from "./roles.vue?vue&type=template&id=2f4fc15c&scoped=true&"
import script from "./roles.vue?vue&type=script&lang=ts&"
export * from "./roles.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f4fc15c",
  null
  
)

export default component.exports